import { render } from "./ExpedientDetailChangeContractTypeModal.vue?vue&type=template&id=0d768c13"
import script from "./ExpedientDetailChangeContractTypeModal.vue?vue&type=script&lang=js"
export * from "./ExpedientDetailChangeContractTypeModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__